<div id="loader" *ngIf="loader"><span class="spinner-border spinner-grow-lg"></span></div>

<div id="transport">
	<table class="table table-striped table-hover">
		<thead>
			<tr>
				<th>Pojazd</th>
				<th></th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let item of vehicles">
				<td>{{ item.name }}</td>
				<td>
					<button class="btn btn-danger" (click)="vehicleChooseOpen(item)">
						<i class="fas fa-exchange-alt"></i> Zamień na inny
					</button>
				</td>
			</tr>
		</tbody>
	</table>
</div>
<div
	class="modal fade"
	id="vehicleModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="vehicleModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title">Wybierz pojazd</h5>
				<button
					type="button"
					class="close"
					data-bs-dismiss="modal"
					aria-label="Close"
					(click)="vehicleChooseClose()"
				>
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
			<div class="modal-body d-grid">
				<button
					type="submit"
					class="btn btn-link"
					*ngFor="let item of vehiclesAll"
					(click)="vehicleChoose(item)"
				>
					{{ item.name }}
				</button>
			</div>
		</div>
	</div>
</div>
